module.exports = __webpack_public_path__ + "static/media/icon_itsuki122b3996cd9f82de3ff21da31e800f3f.webp";